import { fatosApi } from '../../../api/fatosApi'


export async function recuperarFatosRelacionadosDoProcesso(numeroFormatado: string) {
  const { body: respostaIndiceFatos } = await fatosApi.buscarFatosPorProcessoRelacionado(numeroFormatado)
  return respostaIndiceFatos.hits.hits
}
